import ComplianceReport from "../components/engineering/complianceReport/ComplianceReport";
import DwriDataSearch from "../components/engineering/water_use/DwriDataSearch";
import DwriDataContainer from "../components/engineering/water_use/DwriDataContainer";

export const engineeringRoutes = [
    {
        path: "/engineering/dwri/dwri-data-search",
        component: DwriDataSearch,
        requiresWaterSystem: true
    },
    {
        path: "/engineering/dwri/dwri-data-result",
        component: DwriDataContainer,
        requiresWaterSystem: true,
        exact: false
    },
    {
        path: "/engineering/complianceReport/compliance-report",
        component: ComplianceReport
    }
];
